import { render, staticRenderFns } from "./ExpenseCarouselViewModal.vue?vue&type=template&id=3dd5ffc2&scoped=true&"
import script from "./ExpenseCarouselViewModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseCarouselViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCarouselViewModal.vue?vue&type=style&index=0&id=3dd5ffc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd5ffc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd5ffc2')) {
      api.createRecord('3dd5ffc2', component.options)
    } else {
      api.reload('3dd5ffc2', component.options)
    }
    module.hot.accept("./ExpenseCarouselViewModal.vue?vue&type=template&id=3dd5ffc2&scoped=true&", function () {
      api.rerender('3dd5ffc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpenseService/ExpenseCarouselViewModal.vue"
export default component.exports